document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.c-pdp-section');

  sections.forEach((section) => {
    initFixedMediaGallery(section);
    initTabs(section);
    initCoupon(section);
    initQuantity(section);
  });
});

/* =========================
   MEDIA GALLERY FIX
========================= */
function initFixedMediaGallery(section) {
  const mediaRoot = section.querySelector('[data-media-gallery]');
  if (!mediaRoot) return;

  const stageItems = [...mediaRoot.querySelectorAll('[data-media-id]')];
  const thumbs = [...mediaRoot.querySelectorAll('[data-thumb-id]')];
  const prevBtn = mediaRoot.querySelector('[data-gallery-prev]');
  const nextBtn = mediaRoot.querySelector('[data-gallery-next]');

  const zoomModal = section.querySelector('[data-zoom-modal]');
  const openZoomBtn = mediaRoot.querySelector('[data-open-zoom]');
  const closeZoomBtns = section.querySelectorAll('[data-close-zoom]');
  const zoomItems = [...section.querySelectorAll('[data-zoom-media-id]')];
  const zoomThumbs = [...section.querySelectorAll('[data-zoom-thumb-id]')];
  const zoomPrevBtn = section.querySelector('[data-zoom-prev]');
  const zoomNextBtn = section.querySelector('[data-zoom-next]');

  if (!stageItems.length) return;

  let currentIndex = Math.max(
    0,
    stageItems.findIndex((item) => item.classList.contains('is-active'))
  );

  if (currentIndex === -1) currentIndex = 0;

  function updateActiveMedia(index) {
    if (!stageItems.length) return;

    if (index < 0) index = stageItems.length - 1;
    if (index >= stageItems.length) index = 0;

    currentIndex = index;
    const activeId = stageItems[currentIndex].dataset.mediaId;

    stageItems.forEach((item) => {
      item.classList.toggle('is-active', item.dataset.mediaId === activeId);
    });

    thumbs.forEach((thumb) => {
      thumb.classList.toggle('is-active', thumb.dataset.thumbId === activeId);
    });

    zoomItems.forEach((item) => {
      item.classList.toggle('is-active', item.dataset.zoomMediaId === activeId);
    });

    zoomThumbs.forEach((thumb) => {
      thumb.classList.toggle('is-active', thumb.dataset.zoomThumbId === activeId);
    });
  }

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const index = stageItems.findIndex(
        (item) => item.dataset.mediaId === thumb.dataset.thumbId
      );
      if (index !== -1) updateActiveMedia(index);
    });
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      updateActiveMedia(currentIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      updateActiveMedia(currentIndex + 1);
    });
  }

  if (openZoomBtn && zoomModal) {
    openZoomBtn.addEventListener('click', () => {
      zoomModal.hidden = false;
      document.body.classList.add('overflow-hidden');
      updateActiveMedia(currentIndex);
    });
  }

  closeZoomBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!zoomModal) return;
      zoomModal.hidden = true;
      document.body.classList.remove('overflow-hidden');
    });
  });

  zoomThumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const index = stageItems.findIndex(
        (item) => item.dataset.mediaId === thumb.dataset.zoomThumbId
      );
      if (index !== -1) updateActiveMedia(index);
    });
  });

  if (zoomPrevBtn) {
    zoomPrevBtn.addEventListener('click', () => {
      updateActiveMedia(currentIndex - 1);
    });
  }

  if (zoomNextBtn) {
    zoomNextBtn.addEventListener('click', () => {
      updateActiveMedia(currentIndex + 1);
    });
  }

  document.addEventListener('keydown', (event) => {
    if (!zoomModal || zoomModal.hidden) return;

    if (event.key === 'Escape') {
      zoomModal.hidden = true;
      document.body.classList.remove('overflow-hidden');
    }

    if (event.key === 'ArrowLeft') {
      updateActiveMedia(currentIndex - 1);
    }

    if (event.key === 'ArrowRight') {
      updateActiveMedia(currentIndex + 1);
    }
  });

  updateActiveMedia(currentIndex);
}

/* =========================
   TABS FIX
========================= */
function initTabs(section) {
  const tabRoots = section.querySelectorAll('[data-tabs-root]');
  if (!tabRoots.length) return;

  tabRoots.forEach((root) => {
    const buttons = [...root.querySelectorAll('[data-tab-button]')];
    const panels = [...root.querySelectorAll('[data-tab-panel]')];

    if (!buttons.length || !panels.length) return;

    function activateTab(tabKey) {
      buttons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.tabButton === tabKey);
      });

      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.tabPanel === tabKey);
      });
    }

    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const tabKey = button.dataset.tabButton;
        if (!tabKey) return;
        activateTab(tabKey);
      });
    });

    const activeBtn = root.querySelector('[data-tab-button].is-active');
    if (activeBtn?.dataset.tabButton) {
      activateTab(activeBtn.dataset.tabButton);
    } else if (buttons[0]?.dataset.tabButton) {
      activateTab(buttons[0].dataset.tabButton);
    }
  });
}

/* =========================
   COUPON COPY
========================= */
function initCoupon(section) {
  const copyBtn = section.querySelector('[data-copy-coupon]');
  const codeEl = section.querySelector('[data-coupon-code]');
  const copiedEl = section.querySelector('[data-copied-text]');

  if (!copyBtn || !codeEl || !copiedEl) return;

  copyBtn.addEventListener('click', async (e) => {
    e.preventDefault();

    try {
      await navigator.clipboard.writeText(codeEl.textContent.trim());
      copiedEl.hidden = false;

      setTimeout(() => {
        copiedEl.hidden = true;
      }, 1500);
    } catch (error) {
      console.error('Coupon copy failed', error);
    }
  });
}

/* =========================
   QUANTITY FIX
========================= */
function initQuantity(section) {
  const qtyWraps = section.querySelectorAll('.c-pdp-qty');
  if (!qtyWraps.length) return;

  qtyWraps.forEach((wrap) => {
    const minusBtn = wrap.querySelector('[data-qty-minus]');
    const plusBtn = wrap.querySelector('[data-qty-plus]');
    const input = wrap.querySelector('[data-qty-input]');

    if (!input) return;

    const normalizeValue = (newValue) => {
      let value = parseInt(newValue, 10);
      if (isNaN(value) || value < 1) value = 1;
      return value;
    };

    const setValue = (newValue, triggerEvents = true) => {
      const value = normalizeValue(newValue);
      input.value = value;

      if (triggerEvents) {
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    };

    if (minusBtn) {
      minusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt(input.value || '1', 10) || 1;
        setValue(current - 1, true);
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt(input.value || '1', 10) || 1;
        setValue(current + 1, true);
      });
    }

    input.addEventListener('change', () => {
      input.value = normalizeValue(input.value);
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const galleries = document.querySelectorAll('[data-media-gallery]');

  galleries.forEach(function (gallery) {
    const thumbs = Array.from(gallery.querySelectorAll('.c-pdp-media__thumb'));
    const thumbList = gallery.querySelector('[data-thumb-list]');
    const thumbPrevBtn = gallery.querySelector('[data-thumb-prev]');
    const thumbNextBtn = gallery.querySelector('[data-thumb-next]');

    let thumbStartIndex = 0;
    const visibleCount = 4;

    function getMaxStart() {
      return Math.max(0, thumbs.length - visibleCount);
    }

    function scrollToIndex(index) {
      if (!thumbList || !thumbs.length) return;

      const maxStart = getMaxStart();

      thumbStartIndex = Math.max(0, Math.min(index, maxStart));

      // 🔥 CORE FIX (no more jump)
      const targetThumb = thumbs[thumbStartIndex];
      const offset = targetThumb.offsetTop;

      thumbList.style.transform = `translateY(-${offset}px)`;

      updateButtons();
    }

    function updateButtons() {
      const maxStart = getMaxStart();

      if (!thumbPrevBtn || !thumbNextBtn) return;

      thumbPrevBtn.disabled = thumbStartIndex <= 0;
      thumbNextBtn.disabled = thumbStartIndex >= maxStart;
    }

    // 🔥 BUTTON CLICK FIXED
    if (thumbPrevBtn) {
      thumbPrevBtn.addEventListener('click', function () {
        if (thumbStartIndex <= 0) return;
        scrollToIndex(thumbStartIndex - 1);
      });
    }

    if (thumbNextBtn) {
      thumbNextBtn.addEventListener('click', function () {
        if (thumbStartIndex >= getMaxStart()) return;
        scrollToIndex(thumbStartIndex + 1);
      });
    }

    // INIT
    scrollToIndex(0);
  });
});